'use client';

import React, { FC } from 'react';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import styles from './Documentation.module.scss';
import Layout from '@/src/components/layout/Layout';
import Breadcrumbs from '@/src/components/ui/breadcrumbs/Breadcrumbs';
import { ITheme } from '@/src/lib/types/themeInterface';
import PortableTextSection from '@/src/components/sections/portableTextSection/PortableTextSection';
import SubscribeSection from '@/src/components/sections/subscribeSection/SubscribeSection';

type TDocData = {
  docData: Partial<ITheme>;
};

const Documentation: FC<TDocData> = ({ docData }) => {
  return (
    <Layout>
      <Breadcrumbs />
      <Wrapper className={styles.wrapper}>
        {docData && docData.content && <PortableTextSection content={docData.content} />}
      </Wrapper>
      <SubscribeSection themeSlug={docData.slug} colorScheme={'dark'} />
    </Layout>
  );
};

export default Documentation;
